module.exports = __webpack_public_path__ + "img/data-bg.664f0d3b.png";